<agr-dialog [data]="data" (cancel)="cancel()" (confirm)="confirm()" class="add-to-cart" data-test="add-to-cart">
  <div class="spacing--margin-top">{{ 'add-to-cart.quantity-title' | translate }}</div>
  <div class="flex flex__column spacing--margin-bottom">
    <div class="flex__child">
      <div class="text--small text--gray spacing--padding-top">
        {{ 'add-to-cart.minimum-order-unit-quantity' | translate }}
      </div>
      <div>
        {{ data.catalogItem.orderingInformation.minimumOrderUnitQuantity }}
        {{ 'unit.' + data.catalogItem.orderingInformation.orderUnit | translate }}
      </div>
    </div>
    <div class="flex__child">
      <div class="text--small text--gray spacing--padding-top">
        {{ 'add-to-cart.increase-order-unit-quantity' | translate }}
      </div>
      <div>
        {{ data.catalogItem.orderingInformation.increaseOrderUnitQuantity }}
        {{ 'unit.' + data.catalogItem.orderingInformation.orderUnit | translate }}
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div [formGroup]="formGroup" class="spacing--margin-top">
    <mat-form-field data-test="add-to-cart__quantity">
      <mat-label>{{ 'add-to-cart.quantity' | translate }}</mat-label>
      <input
        data-test="add-to-cart__quantity-input"
        matInput
        agrNumber
        #quantityInput
        formControlName="quantity"
        (keypress)="keyPress($event)"
        [min]="data.catalogItem.orderingInformation.minimumOrderUnitQuantity"
        [max]="data.catalogItem.orderingInformation.maximumOrderUnitQuantity"
        [step]="data.catalogItem.orderingInformation.increaseOrderUnitQuantity"
      />
      <span matSuffix>{{ 'unit.' + data.catalogItem.orderingInformation.orderUnit | translate }}</span>
      <mat-error *ngIf="formGroup.controls.quantity.invalid" data-test="add-to-cart__error">{{ 'add-to-cart.quantity-error' | translate }}</mat-error>
    </mat-form-field>
  </div>
</agr-dialog>
